import {
  forwardRef,
  Highlight,
  SystemStyleObject,
  Text,
  TextProps,
} from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { getSearchMatchWithFilters } from '~/utils/common'

type HighlightTextProps = Omit<TextProps, 'children'> & {
  query?: string | string[]
  permutationFilters?: string[]
  children: string
  highlightStylesOverride?: SystemStyleObject
}

export const HighlightText = forwardRef<HighlightTextProps, 'p'>(
  (props: HighlightTextProps, ref) => {
    const {
      query,
      permutationFilters: queryFilters,
      children,
      highlightStylesOverride,
      ...rest
    } = props

    const resolvedQueries = useMemo(() => {
      const queries = Array.isArray(query) ? query : [query]
      const filteredQueries = queries.filter((q) => q && q !== '')

      if (filteredQueries.length === 0) {
        return []
      }

      if (!queryFilters) {
        return query
      }

      //for every filter, add a query permutation at every index in the source query
      const resolved: string[] = []
      for (let i = 0; i < filteredQueries.length; i++) {
        const query = filteredQueries[i] ?? ''
        const highlighted = getSearchMatchWithFilters(
          children,
          query,
          queryFilters,
        )

        if (highlighted) {
          resolved.push(highlighted)
        }
      }

      return resolved
    }, [query, queryFilters])

    return (
      <Text ref={ref} {...rest}>
        <Highlight query={resolvedQueries!} styles={highlightStylesOverride}>
          {children}
        </Highlight>
      </Text>
    )
  },
)
